@use '@design/design-tokens/typography/typography' as *;

.childFilterDropdownTrigger {
  display: flex;
  align-items: center;
  gap: 4px;
  @include typography-v2-title-lg;
  color: var(--text-primary);
  cursor: pointer;
}
